export const escaContacts = {
  phones: ['+380668356279', '+380960465744'],
  email: 'sales@e-s-c-a.com',
  telegram: 'https://t.me/sergeydenisyuk',
  linkedin: 'https://www.linkedin.com/company/esca-recruitment/',
} as const

export function formatPhone(raw: string): string {
  // +380668356279 -> +380 (66) 835-62-79
  const d = raw.replace(/\D/g, '')
  if (d.length !== 12) return raw
  return `+${d.slice(0, 3)} (${d.slice(3, 5)}) ${d.slice(5, 8)}-${d.slice(8, 10)}-${d.slice(10)}`
}
